import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'bv-i18n';
import { Icon } from 'bv-components';
import { format } from 'bv-helpers/number';

const BalanceView = ({
  showBalance,
  setShowBalance,
  refreshing,
  refreshBalance,
  balance: {
    mainBalance,
    bonusBalance,
  },
}) => (
  <div className="site-header-balance-wrapper">
    {showBalance ? (
      <>
        <div className="site-header-balance bvs-link" onClick={() => { setShowBalance(false); }}>
          <div className="site-header-balance__bonus-balance">
            <span>{t('javascript.balance.bonus')}</span>
            {' '}
            <span>{format(bonusBalance)}</span>
          </div>
          <div className="site-header-balance__main-balance">
            <span>{t('javascript.balance.main')}</span>
            {' '}
            <span>{format(mainBalance)}</span>
          </div>
        </div>
        <Icon
          className={`bvs-link site-header-balance__refresh${refreshing ? ' is-refreshing' : ''}`}
          id="refresh"
          big
          onClick={refreshBalance}
        />
      </>
    ) : (
      <div className="site-header-balance bvs-link" onClick={() => { setShowBalance(true); }}>
        <div className="site-header-balance__main-balance is-hidden">
          {t('show_balance')}
        </div>
      </div>
    )}
  </div>
);

BalanceView.propTypes = {
  showBalance: PropTypes.bool.isRequired,
  setShowBalance: PropTypes.func.isRequired,
  refreshing: PropTypes.bool.isRequired,
  refreshBalance: PropTypes.func.isRequired,
  balance: PropTypes.shape({
    mainBalance: PropTypes.string.isRequired,
    bonusBalance: PropTypes.string.isRequired,
  }).isRequired,
};

export default BalanceView;
